// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","controls":"controls-32wGj","button":"button-hUzCW","clear":"clear-1Xl1j"};